import {
  BoldItalicUnderlineToggles,
  MDXEditor,
  UndoRedo,
  toolbarPlugin,
} from '@mdxeditor/editor';
import React, { useState } from 'react';

interface IRichTextEditorProperties {
  initialText?: string;
  onChange: (string) => void;
  placeholder?: string;
}

export const RichTextEditor: React.FC<IRichTextEditorProperties> = ({
  initialText,
  onChange,
  placeholder,
}) => {
  const [text, setText] = useState<string>(initialText ?? '');

  return (
    <MDXEditor
      markdown={text}
      className="w-100 dark-theme"
      plugins={[
        toolbarPlugin({
          toolbarClassName: 'my-classname',
          toolbarContents: () => (
            <>
              <UndoRedo />
              <BoldItalicUnderlineToggles />
            </>
          ),
        }),
      ]}
      placeholder={placeholder}
      onBlur={(e) => onChange(text.replace(/&#x20;/g, ' '))}
      onChange={(markdown) => setText(markdown)}
    />
  );
};
